export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./profile.vue?vue&type=template&id=61739c89"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/profile.vue?vue&type=template&id=61739c89
// module id = /dhG
// module chunks = 0